// Pagination constants for medical plan explorer
export const MEDICAL_PLAN_PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  DEFAULT_PAGE_NUMBER: 1,
} as const

// Cache configuration for medical plan queries
export const MEDICAL_PLAN_CACHE = {
  STALE_TIME_MS: 5 * 60 * 1000, // Keep data fresh for 5 minutes
} as const
